import { defineMessages } from "@/i18n";
import en from "./en";

export const compactCursorMessages = defineMessages("compact-cursor", en);
